import { TContentType } from '@/types/Content.types';

export const CONTENT_TYPE_LABEL: Record<TContentType, string> = {
  video: 'Reel',
  article: 'Article',
  post: 'Post',
};

export const getContentTypeLabel = (type: TContentType): string => CONTENT_TYPE_LABEL[type];
